import styles from "../CreatorsPage.module.scss";
import { img } from "./images";
import ApplyForm from "./ApplyForm";

const Apply = () => (
	<section className={styles.apply} id="apply" aria-labelledby="apply-h">
		<div className={`${styles.wrap} ${styles.applygrid}`}>
			<div>
				<div className={styles.secHead}>
					<span className={styles.eyebrow}>Apply</span>
					<h2 className={styles.h2} id="apply-h">
						Tell us about you
					</h2>
					<p className={styles.lede}>We read every application and reply within a week.</p>
				</div>
				<ApplyForm />
			</div>
			<div className={styles.collage} aria-hidden="true">
				<img className={styles.c1} src={img("madeira-pol.webp")} alt="" />
				<img className={styles.c2} src={img("portrait.webp")} alt="" />
				<img className={styles.c3} src={img("holbox.webp")} alt="" />
				<span className={`${styles.fl} ${styles.f1}`}>
					+€0.50 <small>new traveller</small>
				</span>
				<span className={`${styles.fl} ${styles.f2}`}>
					80% <small>per guide sold</small>
				</span>
				<span className={`${styles.fl} ${styles.f3}`}>🏔️ 11 hikes saved</span>
			</div>
		</div>
	</section>
);

export default Apply;
